import React, { useState } from 'react';
import FormList from '../components/FormList';
import { useAuth } from '../../../contexts/AuthContext';
import { Button } from '@/components/ui';
import { type ApprovalFormType } from '../config/approvalFormTypes';

const FormsView: React.FC = () => {
  const { loading } = useAuth();
  const [selectedFormType, setSelectedFormType] = useState<ApprovalFormType>('all');
  const [refreshKey, setRefreshKey] = useState(0);
  const [isSearchVisible, setIsSearchVisible] = useState(false);

  const handleRefresh = () => {
    setRefreshKey(prevKey => prevKey + 1);
  };

  const toggleSearch = () => {
    setIsSearchVisible(prev => !prev);
  };

  if (loading) {
    return <div className="tw-w-full tw-p-4">Loading...</div>;
  }

  return (
    // Fill the app shell and scroll the list region internally.
    <div className="tw-w-full tw-flex tw-flex-col tw-flex-1 tw-min-h-0 tw-p-4">
      <div className="tw-flex tw-flex-wrap tw-justify-between tw-items-center tw-gap-3 tw-mb-4 tw-shrink-0">
        <h1 className="tw-mb-0">Form Submissions</h1>
        <div className="tw-flex tw-gap-2">
          <Button
            variant="outline-secondary"
            onClick={handleRefresh}
          >
            <i className="bi bi-arrow-clockwise tw-mr-2"></i>
            Refresh
          </Button>
          <Button
            variant={isSearchVisible ? 'primary' : 'outline-primary'}
            onClick={toggleSearch}
            title={isSearchVisible ? "Close search" : "Search forms"}
          >
            <i className={`bi ${isSearchVisible ? 'bi-x-lg' : 'bi-search'} tw-mr-2`}></i>
            Search
          </Button>
        </div>
      </div>

      <div className="tw-flex-1 tw-min-h-0 tw-overflow-y-auto tw--mx-4 tw-px-4">
        <FormList
          key={refreshKey}
          formType={selectedFormType}
          onFormTypeChange={setSelectedFormType}
          isSearchVisible={isSearchVisible}
          onToggleSearch={toggleSearch}
        />
      </div>
    </div>
  );
};

export default FormsView;
